import script from "./AcademyArticleRealtime3.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademyArticleRealtime3.vue?vue&type=script&setup=true&lang=js"

import "./AcademyArticleRealtime3.vue?vue&type=style&index=0&id=31eb568c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31eb568c"]])

export default __exports__